import { CheckCircle, Clock, XCircle } from "@phosphor-icons/react";

const reimbursementStyles = {
  paid: { label: "Paid", icon: CheckCircle, className: "border-[hsl(var(--success))] bg-[hsl(var(--success))] text-white" },
  unpaid: { label: "Unpaid", icon: Clock, className: "border-[hsl(var(--warning))]/70 bg-[hsl(var(--warning))]/10 text-[hsl(var(--warning))]" },
};

const cashAdvanceStyles = {
  pending: { label: "Pending", icon: Clock, className: "border-[hsl(var(--warning))]/70 bg-[hsl(var(--warning))]/10 text-[hsl(var(--warning))]" },
  approved: { label: "Approved", icon: CheckCircle, className: "border-[hsl(var(--success))] bg-[hsl(var(--success))] text-white" },
  rejected: { label: "Rejected", icon: XCircle, className: "border-destructive/70 bg-destructive/10 text-destructive" },
  lunas: { label: "Paid off", icon: CheckCircle, className: "border-[hsl(var(--success))] bg-[hsl(var(--success))] text-white" },
};

function StatusPill({ state }) {
  const Icon = state.icon;
  return (
    <span className={`inline-flex h-9 items-center gap-1.5 rounded-full border px-3 text-xs font-semibold ${state.className}`}>
      <Icon size={15} weight={state.icon === Clock ? "bold" : "fill"} />
      {state.label}
    </span>
  );
}

export function ReimbursementStatusPill({ status }) {
  return <StatusPill state={reimbursementStyles[status] || reimbursementStyles.unpaid} />;
}

export function CashAdvanceStatusPill({ status }) {
  return <StatusPill state={cashAdvanceStyles[status] || cashAdvanceStyles.pending} />;
}
